(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ProductDetailController', ProductDetailController);
   /* ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'Product'];

    function ProductDetailController($scope, $rootScope, $stateParams, DataUtils, Product) {
    var vm = this;
    vm.product1 = [{code:'BAB01',name:'Tan gia bại sản', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NB sales',unit:'Quyển',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
                  {code:'BAB02',name:'Tán gia bại sản', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N2-NB sales',unit:'Tờ',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
                  {code:'BAB03',name:'Tích lũy cả đời', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N3-NB sales',unit:'Cái',seriesNum:'1457758 - 22222222',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
                  {code:'BAB04',name:'An gia tích lũy định kỳ', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N4-NB sales',unit:'Quyển',seriesNum:'1457758 - 19999999',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
                  {code:'BAB05',name:'An hưởng thịnh vượng', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NF sales',unit:'Quyển',seriesNum:'1457758 - 44444444',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'},
                  {code:'BHB06',name:'An hưởng thịnh vượng', beginDate:'03-01-2013',endDate:'03-01-2013',budget:'N1-NG sales',unit:'Quyển',seriesNum:'1457758 - 7777777',seriesBegin:'1457758',seriesEnd:'19999999',description:'Mô tả',status:'1',bookTime:'30'}];
    vm.product = vm.product1[0]*/

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Product'];

    function ProductDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Product) {
        var vm = this;
        vm.product = entity;
        vm.listFile = vm.product.lstArchiveData;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.product.status == 1){
        	vm.product.statusName = 'Đang hoạt động'
        }else{
        	vm.product.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:ClaimHospitalUpdate', function(event, result) {
            vm.product = result;
            
        });
        vm.dateOptionsPr = {
    			maxDate : new Date()
    	};
        $scope.$on('$destroy', unsubscribe);
        $scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
           				'shortDate' ];
        $scope.format = $scope.formats[2];
        $scope.altInputFormats = [ 'M!/d!/yyyy' ];
    }
})();
